<template>
  <div class="header header-background">
    <a :href="getMainLink()">
      <div v-if="locale === 'en'">
        <img src="@img/logo-en-hover.svg" alt="" class="logo-img" @mouseenter="mouseEnter()" @mouseleave="mouseLeave()" v-if="logoHovered">
        <img src="@img/logo-en.svg" alt="" class="logo-img" @mouseenter="mouseEnter()" @mouseleave="mouseLeave()" v-else>
      </div>
      <div v-else>
        <img src="@img/logo-hover.svg" alt="" class="logo-img" @mouseenter="mouseEnter()" @mouseleave="mouseLeave()" v-if="logoHovered">
        <img src="@img/logo.svg" alt="" class="logo-img" @mouseenter="mouseEnter()" @mouseleave="mouseLeave()" v-else>
      </div>
    </a>

    <div class="dashboard-item-wrapper">
      <div class="centered_div" v-show="showHeaderInstrumentsDesktop">
        <div class="dashboard-content__categories__item-text">
          <p class="dashboard-content__categories__item-text white_col">{{ humanServiceName(serviceName) }}</p>
        </div>
        <div class="dashboard-content__selector">
          <div class="dashboard-content__selector__item"
               @click="goInterfaceSpecialist()">
            {{ locale === 'en' ? 'Map' : 'Карта' }}
          </div>
          <div class="dashboard-content__selector__item"
            :class="{'dashboard-content__selector__item-selected': selectedTab === 'dashboard'}"
          >
            {{ locale === 'en' ? 'Analytics' : 'Аналитика' }}
          </div>
        </div>
      </div>
    </div>

    <div class="instruments-desktop" v-show="showHeaderInstrumentsDesktop">
      <div class="main"><a class="white_col" :href="getMainLink()">{{ locale === 'en' ? 'Home' : 'Главная'}}</a></div>
      <!-- <div class="mail">
        <img src="@img/email.svg" alt="mail">
        <div class="mail-counter"
          :class="[serviceName + '-color']"
          >
            5
        </div>
      </div> -->
      <item-profile :show="showMenuName === 'profile'" @close-item="setShowMenuName('')">
        <div class="user" @click="setShowMenuName('profile')">
          <!-- :class="{'user-active': showMenuName === 'profile'}" -->
          <!-- <img src="@img/user.svg" alt="user"> -->
          {{ displayingUsername }}
        </div>
      </item-profile>

    </div>

    <div class="instruments-mobile__wrapper" @click="toggleMobileMenu(true)">
     <div class="instruments-mobile">
       <img src="@img/open-menu.svg" alt="" class="instruments-mobile__img">
     </div>
   </div>

    <transition name="fade">
      <div class="mobile-menu__open" id="mobileMenuHeader" v-show="showMobileMenu">
        <div class="mobile-menu__open__content">
          <div class="mobile-menu__open__button-close" @click="toggleMobileMenu(false)">
            <img src="@img/close.svg" alt="" class="button-close__img">
          </div>
          <div class="mobile-menu__service">
            <div class="mobile-menu__service-icon" :class="[serviceName + '-color-border']">
              <img :src="getImgPath(serviceName)" alt="">
            </div>
            <div class="mobile-menu__service-name">
              {{ humanServiceName(serviceName) }}
            </div>
          </div>
          <div class="mobile-menu__open__content__service-navigation">
            <div class="mobile-menu__open__content__service-navigation__item mobile-menu__open__content__service-navigation__item-selected"
                @click="goInterfaceSpecialist()">
              {{ locale === 'en' ? 'Map' : 'Карта' }}
            </div>
            <div class="mobile-menu__open__content__service-navigation__item">
              {{ locale === 'en' ? 'Analytics' : 'Аналитика' }}
            </div>
          </div>

          <div class="mobile-menu__open__content__menu">
            <div class="mobile-menu__open__content__menu__item" v-for="(service, index) in servicesList" :key="index">
              <a :href="goToService(service.service_id)">
                {{ service.service_title }}
              </a>
            </div>

            <div class="mobile-menu__open__content__menu__divide"></div>

            <a :href="getMainLink()">
              <div class="mobile-menu__open__content__menu__item mobile-menu__open__content__menu__item-bigger">
                {{ locale === 'en' ? 'Home' : 'Главная' }}
              </div>
            </a>
            <!-- <div class="mobile-menu__open__content__menu__item">
              {{ locale === 'en' ? 'Messages' : 'Сообщения' }}
              <div class="mail-mobile">
                <img src="@img/email.svg" alt="mail">
                <div class="mail-counter-mobile"
                  :class="[serviceName + '-color']">
                    5
                </div>
              </div>
            </div> -->
            <a :href="getMainLink() + 'lk/profile'">
              <div class="mobile-menu__open__content__menu__item mobile-menu__open__content__menu__item-bigger">
                {{ locale === 'en' ? 'Account' : 'Личный кабинет' }}
                <!-- <div class="user" style="margin-left: 21px;" @click="setShowMenuName('profile')">
                  {{ displayingUsername }}
                </div> -->
              </div>
            </a>
          </div>
          <!-- <div class="mobile-menu__open__content__language-changer-wrapper">
            <language-changer/>
          </div> -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ItemProfile from '@/components/common/headerItems/ItemProfile'
import languageChanger from '@/components/common/languageChanger'

import appStore from '@storages/appStore'
import adaptiveStore from '@storages/adaptiveStore'

import ecoActiveImg from '@img/eco-monitoring-active.svg'
import quarryActiveImg from '@img/quarry-active.svg'
import constructionActiveImg from '@img/construction-active.svg'
import emergencyActiveImg from '@img/emergency-active.svg'
import legalActiveImg from '@img/legal-active.svg'
import agroActiveImg from '@img/agro-active.svg'
import forestActiveImg from '@img/forest-active.svg'

export default {
  name: 'main-header',
  components: {
    'item-profile': ItemProfile,
    'language-changer': languageChanger
  },
  data () {
    return {
      selectedTab: 'dashboard',
      showMobileMenu: false,
      showMenuName: '',
      logoHovered: false
    }
  },
  computed: {
    locale () {
      return appStore.getters.value('locale')
    },
    displayingUsername () {
      try {
        let _userInfo = appStore.getters.value('profile')
        if (_userInfo !== null && _userInfo !== undefined && 'username' in _userInfo) {
          return _userInfo.username.substring(0, 1)
        } else {
          return '.'
        }
      } catch (error) {
        console.log(error)
        return '.'
      }
    },
    showHeaderInstrumentsDesktop () {
      return adaptiveStore.getters.value('showHeaderInstrumentsDesktop')
    },
    showLaptopMenuButton () {
      return adaptiveStore.getters.value('showLaptopMenuButton')
    },
    showDesktopAppName () {
      return adaptiveStore.getters.value('showDesktopAppName')
    },
    servicesList () {
      let _config = appStore.getters.value('config')
      if ('services' in _config) {
        return _config.services
      }
    },
    serviceName () {
      return appStore.getters.value('name')
    }
  },
  methods: {
    getMainLink () {
      let apiUrl = appStore.getters.value('config').api_url
      return apiUrl.substring(0, apiUrl.indexOf(this.serviceName))
    },
    goToService (serviceId) {
      for (let i = 0; i < this.servicesList.length; i++) {
        if (this.servicesList[i].service_id === serviceId) {
          let _serviceUrl = this.servicesList[i].url
          return _serviceUrl + 'dashboard/'
        }
      }
    },
    getImgPath (serviceId) {
      switch (serviceId) {
        case 'eco':
          return ecoActiveImg

        case 'quarry':
          return quarryActiveImg

        case 'construction':
          return constructionActiveImg

        case 'emergency':
          return emergencyActiveImg

        case 'legal':
          return legalActiveImg

        case 'agro':
          return agroActiveImg

        case 'forest':
          return forestActiveImg

        default:
          break
      }
    },
    humanServiceName (val) {
      return this.servicesList.find(item => { return item.service_id === val }).service_title
    },
    goInterfaceSpecialist () {
      let _service = this.servicesList.find(item => { return item.service_id === this.serviceName })
      window.location.href = _service.url
    },
    mouseEnter () {
      this.logoHovered = true
    },

    mouseLeave () {
      this.logoHovered = false
    },

    setShowMenuName (val) {
      if (this.showMenuName === val) {
        this.showMenuName = ''
      } else {
        this.showMenuName = val
      }
    },

    toggleMobileMenu (val) {
      this.showMobileMenu = val
      this.setBobyScrollMix(!val, 'mobileMenuHeader')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/varibles.scss';
.dashboard-item-wrapper {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding-left: 200px;
}
.dashboard-content__open-block {
  margin-right: 10px;
}
a {
  color: black;
  text-decoration: none;
  margin: 0;
  padding: 0;
  border: 0;
  // font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
:focus {
  outline: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: all ease .4s;
  margin-left: 0;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  // transform: translateX(-110vw);
  margin-left: -110vw;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 40px);
  z-index: 15;
  box-shadow: $Shadow;
  padding: 14px 20px 15px 20px;
  height: min-content;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  align-items: center;
  justify-content: space-between;
}
.logo-img {
  // height: 39.02px;
  width: 145px;
  // margin-left: 4px;
  // margin-top: 2px;
  color: white!important;
}
.logo-img:hover {
  cursor: pointer;
}
.service-name {
  justify-self: start;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-left: 223px;
  margin-bottom: -1px;
}
.service-name__name {
  font-size: 1.1428571428571428rem;
  font-family: "PT Sans";
  font-weight: 400;
  line-height: 1;
  margin-left: 13px;
}
.service-name__img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.eco-color {
  background-color: $eco-color;
  color: white!important;
}
.emergency-color {
  background-color: $emergency-color;
  color: white!important;
}
.quarry-color {
  background-color: $quarry-color;
  color: white!important;
}
.construction-color {
  background-color: $construction-color;
  color: white!important;
}
.legal-color {
  background-color: $legal-color;
  color: white!important;
}
.agro-color {
  background-color: $agro-color;
  color: white!important;
}
.forest-color {
  background-color: $forest-color;
  color: white!important;
}
.service-name__img img{
  width: 22px;
  height: 22px;
}
.main {
  font-size: 18px;
  width: 64px;
  text-align: center;
  margin-top: 3px;
}
.main a {
  color: #606060;
}
.main:hover {
  cursor: pointer;
  text-decoration: underline;
}
.mail {
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-top: 2px;
}
.mail-counter {
  margin-top: -8px;
  margin-left: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  position: absolute;
  border-radius: 50%;
  color: white;
  font-size: 10px;
  font-weight: bold;
}
.mail:hover {
  // background-color: rgba(0, 0, 0, 0.04);
  // background-color: #d5d5d5;
  @include hoverAnimation(#596c93);
  cursor: pointer;
}
.mail img {
  width: 18px;
  height: 18px;
  margin-top: 2px;
}
.dashboard {
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dashboard:hover {
  // background-color: rgba(0, 0, 0, 0.04);
  // background-color: #d5d5d5;
  @include hoverAnimation(#d5d5d5);
  border-radius: 50%;
  cursor: pointer;
}
.dashboard-active:hover {
  background-color: #d5d5d5;
}
.dashboard img {
  width: 17px;
  height: 17px;
}
.user {
  width: 34px;
  height: 34px;
  // background-color: #316fea;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  // box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
  margin-top: 1px;
  font-weight: bold;
  font-size: 18px;
  color: #2d325a;
}
.user:hover {
  cursor: pointer;
  // background-color: #4f89fe;
  // background-color: #d5d5d5;
  @include hoverAnimation(#d5d5d5);
}
.user img {
  width: 12px;
  height: 12px;
}
.user-active {
  background-color: #e2e2e2;
}
.user-active:hover {
  background-color: #e2e2e2;
}
.instruments-desktop {
  // min-width: 160px
  min-width: 108px;
  height: 44px;
  display: flex;
  // margin-top: 4px;
  // float: right;
  justify-content: space-between;
  align-items: center;
}
.instruments-mobile__wrapper {
  display: none;
}
.mobile-menu__open {
  display: none;
}
@media (min-width: 320px) and (max-width: 768px) {
  .header {
    padding: 10px;
    width: calc(100% - 20px);
    height: 57px;
  }
  .service-name {
    display: none;
  }
  .instruments-mobile__wrapper {
    display: block;
    width: fit-content;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: right;
  }
  // .mobile-menu__open__content__header {
  //   padding: 10px;
  //   box-shadow: $Shadow;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  // }
  .instruments-mobile {
    height: 30px;
    width: 30px;
    // background-color: #e2e2e2;
    // border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .instruments-mobile__img {
    width: 18px;
    height: 18px;
  }
  .mobile-menu__open {
    display: block;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    // background-color: #9ba9b7d5;
    z-index: 15;
    overflow-y: auto;
    background-color: #2d325a;
  }
  .mobile-menu__open__button-close {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 20px;
    right: 23px;
  }
  .button-close__img {
    width: 20px;
    height: 20px;
  }
  .mobile-menu__open__content {
    position: relative;
    // max-width: 85%;
    // width: calc(100% - 20px);
    background-color: #2d325a;
    // height: calc(100% - 58px); // 100% - padding-top - padding-bottom
    // box-shadow: 0px 7px 82px 0 rgb(0, 0, 0);
    padding: 29px 0 60px 0;
    // overflow-y: auto;
  }
  .mobile-menu__service {
    padding: 0 60px 0 17px;
    display: flex;
    align-items: center;
  }
  .mobile-menu__service-icon {
    flex: none;
    width: 60px;
    height: 60px;
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #353c6f;
  }
  .mobile-menu__service-icon img {
    // width: 61px;
    height: 32px;
  }
  .mobile-menu__service-name {
    color: white;
    font-size: 18px;
    margin-left: 10px;
  }
  .mobile-menu__open__content__menu {
    width: 100%;
    // height: 100%;
    // overflow-y: auto;
    margin-top: 19px;
  }
  .mobile-menu__open__content__menu__item {
    padding: 8px 20px 18px 17px;
    color: white;
    display: flex;
    align-items: center;
  }
  .mobile-menu__open__content__menu__item a{
    color: white;
    font-size: 18px;
  }
  .mobile-menu__open__content__menu__divide {
    width: 100%;
    height: 1px;
    background-color: #353c70;
    margin-bottom: 8px;
  }
  .mobile-menu__open__content__menu__item-bigger {
    font-size: 24px;
  }
  .mobile-menu__open__content__service-navigation {
    display: flex;
    width: fit-content;
    margin-left: 17px;
    margin-top: 15px;
    // margin-bottom: 15px;
  }
  .mobile-menu__open__content__service-navigation__item {
    border-radius: 10px;
    padding: 14px 32px;
    color: #9da6b3;
    font-size: 14px;
    cursor: pointer;
    border-radius: 10px;
    background-color: #dedcdc;
    margin-right: 6px;
  }
  .mobile-menu__open__content__service-navigation__item-selected {
    background-color: #8299be;
    color: white;
  }
  .mail-mobile {
    width: 42px;
    height: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-top: 2px;
  }
  .mail-counter-mobile {
    margin-top: -8px;
    margin-left: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    position: absolute;
    border-radius: 50%;
    color: white;
    font-size: 10px;
    font-weight: bold;
  }
  .mail-mobile img {
    width: 18px;
    height: 18px;
    margin-top: 2px;
  }
  .mobile-menu__open__content__language-changer-wrapper {
    margin-left: 10px;
    margin-top: 10px;
  }
}
@media (min-width: 768px) and (max-width: 960px) {
  .dashboard-item-wrapper {
    display: flex;
    justify-content: center;
    padding-left: 0;
    align-self: center;
  }
  .dashboard-content__open-block {
    display: none;
  }
  .centered_div {
    display: flex;
  }
  .instruments-desktop {
    display: none;
  }
  .instruments-desktop {
    display: flex;
  }
}
.white_col {
  color : white!important;
}
.dashboard-content__open {
  width: 18px;
}
//new style for checkbox
.dashboard-content__selector {
  border-radius: 10px;
  background-color: #dedcdc;
  display: flex;
  // margin-top: 12px;
  // margin-bottom: 15px;
}
.dashboard-content__selector__item {
  // padding: 11px 30px 10px 30px;
  width: 94.5px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9da6b3;
  font-size: 14px;
  cursor: pointer;
  border-radius: 10px;
}
.dashboard-content__selector__item-selected {
  color: white;
  background-color: #8299be;
}
.dashboard-content__categories {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.dashboard-content__categories__item a {
  // margin-right: 13px;
  width: 100px;
  margin-left: -3px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dashboard-content__categories__item-img {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  border: solid 2px #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dashboard-content__categories__item-img:hover {
  background-color: #d3d3d3;
  cursor: pointer;
}
.dashboard-content__categories__item-img img {
  width: 27px;
  display: block;
  // height: 27px;
}
.centered_div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 45px;
  // padding-left: 50px;
}
.dashboard-content__categories__item-text {
  text-align: left;
  /*width: 62px;*/
  /*width: min-content;*/
  /*margin-bottom: 5px;*/
  color: #383838;
  font-size: 18px;
}
.dashboard-content__categories__item-text p {
  margin-right: 20px;
}
@media (min-width: 320px) and (max-width: 767px) {
  .header {
    box-shadow: none;
    border-bottom: 1px solid #353c70;
  }
  .dashboard-item-wrapper {
    display: flex;
    padding-left: 15px;
    align-self: center;
  }
  .centered_div {
    display: flex;
    position: fixed;
    width: calc(100% - 75px);
    height: 85px;
    flex-direction: column;
    top: 64px;
    left: 75px;
    background-color: #2d325a;
    z-index: 11;
    line-height: 37px;
  }
  .instruments-desktop {
    justify-content: flex-end;
  }
}
@media (min-width: 320px) and (max-width: 475px) {
  .dashboard-item-wrapper {
    justify-content: flex-end;
  }
  .centered_div {
    width: 100%;
    left: 0;
    top: 58px;
    padding-bottom: 30px;
  }
  .dashboard-content__selector {
    margin-top: 20px;
  }
  .instruments-desktop {
    position: fixed;
    top: 170px;
    z-index: 11;
    flex-direction: column;
    width: 100%;
    align-items: center;
    left: 0;
    height: 190px;
    padding-bottom: 30px;
    background-color: #2d325a;
    justify-content: space-between;
  }
  .logo-img {
    width: 145px;
  }
  .dashboard-content__categories__item-text p {
    font-size: 25px;
    margin-right: 0;
  }
  .main {
    width: 100%;
    text-align: center;
  }
  .main a {
    font-size: 33px;
  }
  .mail img {
    width: 49px;
    height: 49px;
  }
  .mail-counter {
    margin-top: -18px;
    margin-left: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    position: absolute;
    border-radius: 50%;
    color: white;
    font-size: 16px;
    font-weight: bold;
  }
  // .user {
  //   width: 50px;
  //   height: 50px;

  //   img {
  //     width: 25px;
  //     height: 25px;
  //   }
  // }

}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue